import { EditIcon, DeleteIcon } from 'app/agriculture/icons';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { EntityTypeToConfigDataMap } from 'app/agriculture/queries/entities/types/EntityTypeConfig';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { isEntityType } from 'app/agriculture/models/Entities';
import { useSelection } from 'app/agriculture/ContextMenu/hooks/useSelection/useSelection';
import { ContextMenuItem } from 'app/agriculture/ContextMenu/ContextMenuItem';
import { useGenericEntity } from 'app/agriculture/queries/entities/useGenericEntity';

interface ContextMenuActionsProps {
    onClick?: () => void;
}

export function ContextMenuActions({ onClick }: ContextMenuActionsProps) {
    const { selection } = useSelection();
    if (!selection) return null;
    const { id } = selection;

    if (typeof id === 'number') return null;

    return (
        <SuspenseWrapper>
            <WrappedContextMenuActions id={id} onClick={onClick} />
        </SuspenseWrapper>
    );
}

function WrappedContextMenuActions({
    id,
    onClick = () => {
        // do nothing
    },
}: { id: string } & ContextMenuActionsProps) {
    const routeActions = useRouteActions();
    const { type } = useGenericEntity(id);

    if (!isEntityType(type)) {
        throw new Error('entity type mismatch');
    }

    const { disableEdit = false, disableDelete = false } = EntityTypeToConfigDataMap[type] ?? {};

    return (
        <>
            {disableEdit ? null : (
                <ContextMenuItem
                    Icon={EditIcon}
                    title={`Edit ${type}`}
                    onClick={() => {
                        onClick();
                        routeActions.edit(id, { type });
                    }}
                />
            )}
            {disableDelete ? null : (
                <ContextMenuItem
                    Icon={DeleteIcon}
                    title={`Delete ${type}`}
                    onClick={() => {
                        onClick();
                        routeActions.remove(id, { type });
                    }}
                />
            )}
        </>
    );
}
